import { render, staticRenderFns } from "./GrupoComissao.vue?vue&type=template&id=7647a348"
import script from "./GrupoComissao.vue?vue&type=script&lang=js"
export * from "./GrupoComissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports